<script setup>
import {onMounted, ref} from 'vue';
import {child, get, ref as dbRef} from 'firebase/database';
import {auth, database} from '@/firebase';
import {useRouter} from 'vue-router';

const quizHistory = ref([]);
const loading = ref(true);
const router = useRouter();

const fetchQuizHistory = async () => {
  const uid = auth.currentUser?.uid;
  if (!uid) return;
  console.log(uid)
  const snapshot = await get(child(dbRef(database), `quiz_results/${uid}`));
  if (snapshot.exists()) {
    const data = snapshot.val();
    quizHistory.value = Object.values(data)
        .map(item => ({
          ...item,
          createdAt: new Date(item.createdAt)
        }))
        .sort((a, b) => b.createdAt - a.createdAt);
  }
  loading.value = false;

};

const startReview = () => {
  router.push('/vocabulary');
};

onMounted(fetchQuizHistory);
</script>

<template>
  <div class="container mt-4">
    <div class="col-lg-12">
      <div class="row mt-4">
        <div class="col-lg-12 mb-lg-0 mb-4">
          <div class="card">
            <div class="p-3 pb-0 card-header">
              <div class="d-flex justify-content-between">
                <h6 class="mb-2">Lịch sử làm bài trắc nghiệm</h6>
                <button class="btn btn-primary" @click="startReview">
                  Bắt đầu ôn tập
                </button>
              </div>
            </div>
            <div class="table-responsive">
              <div v-if="loading" class="text-center p-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Đang tải dữ liệu...</span>
                </div>
              </div>
              <table class="table align-items-center text-center" v-else>
                <thead>
                  <tr>
                    <th>Thời gian</th>
                    <th>Số câu đúng</th>
                    <th>Tổng số câu</th>
                    <th>Tỉ lệ đúng</th>
                  </tr>
                </thead>
                <tbody>
                <tr v-for="(entry, index) in quizHistory" :key="index">
                  <td>
                    {{ entry.createdAt.toLocaleString('vi-VN') }}
                  </td>
                  <td>{{ entry.score }}</td>
                  <td>{{ entry.total }}</td>
                  <td>
                    {{ ((entry.score / entry.total) * 100).toFixed(1) }}%
                  </td>
                </tr>
                </tbody>
              </table>

              <div class="text-center p-4" v-if="quizHistory.length === 0 && loading === false">
                <p>Chưa có lịch sử làm bài.</p>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
